export default "__VITE_ASSET__$P$ESayf__"